import React, { useEffect, useState } from "react";
import { Select, Space } from "antd";

const SelectCityComp = React.forwardRef(
  ({ 
    Disabled = false, 
    onActive = 0, 
    onSelected = () => {},
    ProvinceId = 0
  }, ref) => {
    const [data, setData] = useState([]);
    const [valueS, setValueS] = useState({});

    const onSelecteItem = (item) => {
      let dt = data.find(p=>p.value===item)
      setValueS(item);
      onSelected(dt);
    };
    const getListCityFromLocal = async () => {
      const listState = [
        { value: 0, label: "" },
        { value: 1, label: "Hà Nội" },
        { value: 32, label: "Đà Nẵng" },
        { value: 50, label: "Hồ Chí Minh" },
        { value: 47, label: "Bình Dương" },
        { value: 59, label: "Cần Thơ" },
        { value: 2, label: "Hà Giang" },
        { value: 3, label: "Cao Bằng" },
        { value: 4, label: "Bắc Kạn" },
        { value: 5, label: "Tuyên Quang" },
        { value: 6, label: "Lào Cai" },
        { value: 7, label: "Điện Biên" },
        { value: 8, label: "Lai Châu" },
        { value: 9, label: "Sơn La" },
        { value: 10, label: "Yên Bái" },
        { value: 11, label: "Hòa Bình" },
        { value: 12, label: "Thái Nguyên" },
        { value: 13, label: "Lạng Sơn" },
        { value: 14, label: "Quảng Ninh" },
        { value: 15, label: "Bắc Giang" },
        { value: 16, label: "Phú Thọ" },
        { value: 17, label: "Vĩnh Phúc" },
        { value: 18, label: "Bắc Ninh" },
        { value: 19, label: "Hải Dương" },
        { value: 20, label: "Hải Phòng" },
        { value: 21, label: "Hưng Yên" },
        { value: 22, label: "Thái Bình" },
        { value: 23, label: "Hà Nam" },
        { value: 24, label: "Nam Định" },
        { value: 25, label: "Ninh Bình" },
        { value: 26, label: "Thanh Hóa" },
        { value: 27, label: "Nghệ An" },
        { value: 28, label: "Hà Tĩnh" },
        { value: 29, label: "Quảng Bình" },
        { value: 30, label: "Quảng Trị" },
        { value: 31, label: "Huế" },
        { value: 33, label: "Quảng Nam" },
        { value: 34, label: "Quảng Ngãi" },
        { value: 35, label: "Bình Định" },
        { value: 36, label: "Phú Yên" },
        { value: 37, label: "Khánh Hòa" },
        { value: 38, label: "Ninh Thuận" },
        { value: 39, label: "Bình Thuận" },
        { value: 40, label: "Kon Tum" },
        { value: 41, label: "Gia Lai" },
        { value: 42, label: "Đắk Lắk" },
        { value: 43, label: "Đắk Nông" },
        { value: 44, label: "Lâm Đồng" },
        { value: 45, label: "Bình Phước" },
        { value: 46, label: "Tây Ninh" },
        { value: 48, label: "Đồng Nai" },
        { value: 49, label: "Vũng Tàu" },
        { value: 51, label: "Long An" },
        { value: 52, label: "Tiền Giang" },
        { value: 53, label: "Bến Tre" },
        { value: 54, label: "Trà Vinh" },
        { value: 55, label: "Vĩnh Long" },
        { value: 56, label: "Đồng Tháp" },
        { value: 57, label: "An Giang" },
        { value: 58, label: "Kiên Giang" },
        { value: 60, label: "Hậu Giang" },
        { value: 61, label: "Sóc Trăng" },
        { value: 62, label: "Bạc Liêu" },
        { value: 63, label: "Cà Mau" },
      ];

      setData(ProvinceId === 0 ? listState: listState.filter(e => e.value === ProvinceId));
      if (onActive !== 0) {
        setValueS(onActive);
      } else {
        setValueS(0);
      }
    };

    useEffect(() => {
      getListCityFromLocal();
    }, []);

    useEffect(() => {
      if(onActive !== 0){
        setValueS(onActive);
      }
    }, [onActive]);

    return (
      <Select
        style={{
          width: "100%",
        }}
        placeholder="Chọn tỉnh thành"
        value={valueS}
        options={data}
        optionRender={(option) => (
          <Space>
            <span role="img" aria-label={option.label}>
              {option.label}
            </span>
          </Space>
        )}
        ref={ref}
        isDisabled={Disabled}
        showSearch
        onChange={onSelecteItem}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
      />
    );
  }
);

export const SelectCity = React.memo(SelectCityComp);
